import React from 'react'

class SocialIcon extends React.Component {
    render() {
        return <img className="socialLink" width="24"  src={ this.props.src } alt={ this.props.alt } /> 
    }
}

export default SocialIcon  
